<script lang="ts">

    /* EXPORTS ------------------------------------------------------------------------------- */

    export let title: string = 'SMATCH Buyer App';

</script>

<svelte:head>
    <title>{ title }</title>
</svelte:head>